import { useEffect } from 'react'
import Intercom from '@intercom/messenger-js-sdk'
import { useAuth } from '../context/authentication/useAuth'
import { useFeatureFlagService } from '../utils/useFeatureFlagService'

export default function IntercomMessenger() {
  const { user, isAuthenticated } = useAuth()
  const { enableIntercom, isLoading: isFeatureFlagsLoading } =
    useFeatureFlagService()

  useEffect(() => {
    // Only initialize Intercom if all conditions are met
    if (
      enableIntercom &&
      isAuthenticated &&
      user &&
      user.company?.intercom_workspace_id &&
      !isFeatureFlagsLoading
    ) {
      // Use the user's creation date or current time as fallback
      const createdAtTimestamp = user.date_joined
        ? Math.floor(new Date(user.date_joined).getTime() / 1000)
        : Math.floor(Date.now() / 1000)

      Intercom({
        app_id: user.company.intercom_workspace_id,
        name: `${user.first_name} ${user.last_name}`.trim() || user.email,
        email: user.email,
        created_at: createdAtTimestamp,
      })
    }

    // Cleanup function to shutdown Intercom when component unmounts or conditions change
    return () => {
      if (
        enableIntercom &&
        isAuthenticated &&
        user?.company?.intercom_workspace_id
      ) {
        try {
          Intercom({
            app_id: user?.company?.intercom_workspace_id || '',
            action: 'shutdown',
          })
        } catch (error) {
          // Silently handle any shutdown errors
          console.debug('Intercom shutdown error:', error)
        }
      }
    }
  }, [enableIntercom, isAuthenticated, user, isFeatureFlagsLoading])

  // This component doesn't render anything visible
  return null
}
